import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { MultimodalTransportation } from "../../../api";

export const multimodalTransportationKeys = {
  models: () => ["multimodalTransportationModels"],
  items: () => ["multimodalTransportationItems"],
  transportTypes: () => ["transportTypes"],
};

export function useGetModels(config) {
  const { callApi } = useAuth();
  return useQuery(multimodalTransportationKeys.models(),
    () => callApi(MultimodalTransportation.getModels), config);
}

export function useCreateModel(config) {
  const { callApi } = useAuth();
  return useMutation(({ data }) =>
    callApi(MultimodalTransportation.createModel, { data }), config);
}

export function useUpdateModel(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) =>
    callApi(MultimodalTransportation.updateModel, { id, data }), config);
}

export function useDeleteModel(config) {
  const { callApi } = useAuth();
  return useMutation(({ id }) =>
    callApi(MultimodalTransportation.deleteModel, { id }), config);
}

export function useGetMultimodalTransportationItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...multimodalTransportationKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(MultimodalTransportation.getMultimodalTransportationItems, params), config);
}

export function useAddMultimodalTransportationItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ modelId, data }) =>
    callApi(MultimodalTransportation.addMultimodalTransportationItems, { modelId, data }), config);
}

export function useUpdateMultimodalTransportationItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ modelId, recordId, data }) =>
    callApi(MultimodalTransportation.updateMultimodalTransportationItem, { modelId, recordId, data }), config);
}

export function useDeleteMultimodalTransportationItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ modelId, recordId }) =>
    callApi(MultimodalTransportation.deleteMultimodalTransportationItem, { modelId, recordId }), config);
}